import React from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import { Link } from 'react-router'
import Breadcrumb from 'component/Breadcrumb'

const OccurrencesCode8 = (props) => {
  const { translate } = props

  const renderBreadcrumb = () => {
    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('occurrences-code8.title') },
    ]

    return <Breadcrumb steps={steps} />
  }

  return (
    <div className='code8-ocurrences-page'>
      {renderBreadcrumb()}

      <div className='margin-left-double margin-right-double'>
        <Row className='margin-bottom-double padding-bottom-double'>
          <div className='center'>
            <Col xs={12} sm={6} md={6}>
              <div className='rectangle border rounded padding-top-double'>
                <Link to='/occurrences-code8/previous-day'>
                  <div className='medium-icon margin-top'>
                    <i className='glyph glyph-clock' />
                  </div>
                  <h3 className='name color-text'>
                    {translate('mobile.previousDayOccurrences-code8')}
                  </h3>
                </Link>
              </div>
            </Col>

            <Col xs={12} sm={6} md={6}>
              <div className='rectangle border rounded padding-top-double'>
                <Link to='/occurrences-code8/older'>
                  <div className='medium-icon margin-top'>
                    <i className='glyph glyph-calendar' />
                  </div>
                  <h3 className='name color-text'>
                    {translate('mobile.olderOccurrences-code8')}
                  </h3>
                </Link>
              </div>
            </Col>
          </div>
        </Row>
      </div>
    </div>
  )
}

OccurrencesCode8.propTypes = {
  translate: PropTypes.func.isRequired,
}

export default OccurrencesCode8
